/* Eleganza — eigen verlanglijst.
 *
 * Waarom eigen: de betaalde app (Wishlist King) stond wel geinstalleerd maar had
 * nergens een knop, dus klanten zagen een hartje in de balk dat naar een lijst
 * wees die nooit gevuld kon worden. Zelf bouwen is hier goedkoper en geeft ons
 * de koppeling die het interessant maakt: Klaviyo mailt bij prijsdaling.
 *
 * Opslag: localStorage. Bewust GEEN eigen database in v1 -- de lijst werkt zo
 * meteen voor iedereen, ook voor gasten, zonder inlog of wrijving.
 *
 * Klaviyo krijgt elk toevoegen/verwijderen als event. Bewust exact de namen
 * 'Added To Wishlist' / 'Removed From Wishlist' die er al sinds 2023 staan van
 * de vorige app: zo erven we die historie en krijgen we geen tweede metric die
 * alleen in hoofdletters verschilt. Voor bezoekers die Klaviyo
 * herkent (mail geopend of eerder besteld -- hetzelfde mechanisme waarop Browse
 * Abandonment al draait) is dat de bron voor de prijsdalings-mail. Anonieme
 * bezoekers houden een werkende lijst, maar krijgen geen mail; dat is de
 * bekende grens en gold voor de betaalde app net zo goed.
 */
(function () {
  'use strict';

  var SLEUTEL = 'eleganza_wishlist';
  var GEBEURTENIS = 'eleganza:wishlist-changed';

  function lees() {
    try {
      var ruw = window.localStorage.getItem(SLEUTEL);
      var lijst = ruw ? JSON.parse(ruw) : [];
      return Array.isArray(lijst) ? lijst : [];
    } catch (e) {
      // Prive-modus of geblokkeerde opslag: geen lijst, maar de pagina moet
      // gewoon blijven werken.
      return [];
    }
  }

  function schrijf(lijst) {
    try {
      window.localStorage.setItem(SLEUTEL, JSON.stringify(lijst));
    } catch (e) {
      /* opslag vol of geblokkeerd -- stil doorgaan */
    }
    document.dispatchEvent(new CustomEvent(GEBEURTENIS, { detail: { aantal: lijst.length } }));
  }

  function klaviyo(naam, item) {
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['track', naam, {
        ProductID: item.id,
        ProductName: item.titel,
        Handle: item.handle,
        URL: item.url,
        ImageURL: item.foto,
        Price: item.prijs,
        CompareAtPrice: item.vanprijs || null,
        Brand: item.merk || '',
        VariantID: item.variant || null,
      }]);
    } catch (e) {
      /* Klaviyo nog niet geladen -- de lijst zelf blijft werken */
    }
  }

  var Wishlist = {
    lijst: lees,

    aantal: function () {
      return lees().length;
    },

    heeft: function (id) {
      return lees().some(function (p) { return String(p.id) === String(id); });
    },

    toggle: function (item) {
      var lijst = lees();
      var i = lijst.findIndex(function (p) { return String(p.id) === String(item.id); });
      if (i >= 0) {
        lijst.splice(i, 1);
        schrijf(lijst);
        klaviyo('Removed From Wishlist', item);
        return false;
      }
      item.toegevoegd = new Date().toISOString();
      lijst.unshift(item);
      schrijf(lijst);
      klaviyo('Added To Wishlist', item);
      // Meteen als verstuurd noteren; de inhaalslag hierboven hoeft dit item
      // alleen nog op te pakken als Klaviyo de bezoeker toen niet kende.
      try {
        var g = JSON.parse(window.localStorage.getItem('eleganza_wishlist_gesynct') || '[]');
        if (window.klaviyo && g.indexOf(String(item.id)) === -1) {
          window.klaviyo.isIdentified && window.klaviyo.isIdentified().then(function (bekend) {
            if (!bekend) return;
            g.push(String(item.id));
            window.localStorage.setItem('eleganza_wishlist_gesynct', JSON.stringify(g));
          });
        }
      } catch (e) { /* niet fataal */ }
      return true;
    },

    verwijder: function (id) {
      var lijst = lees();
      var item = lijst.find(function (p) { return String(p.id) === String(id); });
      var rest = lijst.filter(function (p) { return String(p.id) !== String(id); });
      schrijf(rest);
      if (item) klaviyo('Removed From Wishlist', item);
    },
  };

  window.EleganzaWishlist = Wishlist;

  // --- knoppen ------------------------------------------------------------
  function stand(knop) {
    var actief = Wishlist.heeft(knop.dataset.wishlistId);
    knop.classList.toggle('is-actief', actief);
    knop.setAttribute('aria-pressed', actief ? 'true' : 'false');
    var label = actief ? knop.dataset.labelUit : knop.dataset.labelAan;
    if (label) {
      knop.setAttribute('aria-label', label);
      knop.setAttribute('title', label);
      var tekst = knop.querySelector('[data-wishlist-tekst]');
      if (tekst) tekst.textContent = label;
    }
  }

  function koppel(knop) {
    if (knop.dataset.wishlistKlaar) return;
    knop.dataset.wishlistKlaar = '1';
    stand(knop);
    // Het hartje op de grote foto is een <span role="button"> (zie de snippet);
    // die krijgt geen gratis toetsenbordbediening, dus die regelen we hier.
    if (knop.tagName !== 'BUTTON') {
      knop.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          knop.click();
        }
      });
    }

    knop.addEventListener('click', function (e) {
      // Het hartje op een collectiekaart ligt in de link naar het product.
      e.preventDefault();
      e.stopPropagation();
      Wishlist.toggle({
        id: knop.dataset.wishlistId,
        handle: knop.dataset.wishlistHandle,
        titel: knop.dataset.wishlistTitel,
        url: knop.dataset.wishlistUrl,
        foto: knop.dataset.wishlistFoto,
        prijs: parseFloat(knop.dataset.wishlistPrijs || '0'),
        vanprijs: parseFloat(knop.dataset.wishlistVanprijs || '0') || null,
        merk: knop.dataset.wishlistMerk,
        variant: knop.dataset.wishlistVariant,
      });
    });
  }

  function koppelAlles(root) {
    (root || document).querySelectorAll('[data-wishlist-knop]').forEach(koppel);
  }

  function tellerBij() {
    var n = Wishlist.aantal();
    document.querySelectorAll('[data-wishlist-teller]').forEach(function (el) {
      el.textContent = n > 0 ? n : '';
      el.classList.toggle('is-leeg', n === 0);
    });
  }

  document.addEventListener(GEBEURTENIS, function () {
    tellerBij();
    document.querySelectorAll('[data-wishlist-knop]').forEach(stand);
  });

  // --- inhaalslag naar Klaviyo ---------------------------------------------
  // Klaviyo registreert GEEN events voor een bezoeker die het nog niet kent (de
  // push verdwijnt stil in de wachtrij). Iemand kan dus anoniem een lijstje
  // opbouwen en pas weken later herkend worden -- door een mail te openen of te
  // bestellen. Zonder inhaalslag is dat lijstje voor Klaviyo nooit ontstaan, en
  // krijgt juist die klant geen prijsdalings-mail.
  //
  // Daarom bij elke pageview: als Klaviyo de bezoeker inmiddels kent, stuur dan
  // alsnog alles op dat nog niet verstuurd is. Per item eenmalig, bijgehouden in
  // dezelfde browser.
  var GESTUURD = 'eleganza_wishlist_gesynct';

  function alGestuurd() {
    try {
      return JSON.parse(window.localStorage.getItem(GESTUURD) || '[]');
    } catch (e) {
      return [];
    }
  }

  function haalIn() {
    var lijst = lees();
    if (!lijst.length) return;
    var gedaan = alGestuurd();
    var open = lijst.filter(function (p) { return gedaan.indexOf(String(p.id)) === -1; });
    if (!open.length) return;
    open.forEach(function (p) { klaviyo('Added To Wishlist', p); });
    try {
      window.localStorage.setItem(GESTUURD, JSON.stringify(
        gedaan.concat(open.map(function (p) { return String(p.id); }))));
    } catch (e) { /* niet fataal */ }
  }

  function probeerInhalen() {
    if (!window.klaviyo || typeof window.klaviyo.isIdentified !== 'function') return;
    try {
      var uitkomst = window.klaviyo.isIdentified();
      if (uitkomst && typeof uitkomst.then === 'function') {
        uitkomst.then(function (bekend) { if (bekend) haalIn(); });
      } else if (uitkomst) {
        haalIn();
      }
    } catch (e) { /* Klaviyo nog niet klaar -- volgende pageview dan */ }
  }

  function start() {
    koppelAlles();
    tellerBij();
    // Klaviyo laadt asynchroon; even geduld voordat we het vragen.
    (window.requestIdleCallback || window.setTimeout)(probeerInhalen, { timeout: 3000 });
    setTimeout(probeerInhalen, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Het thema laadt collecties bij (filteren, oneindig scrollen) zonder de
  // pagina te herladen; zonder dit blijven die nieuwe kaartjes doodse hartjes.
  //
  // Wel zuinig: analytics- en app-scripts voegen continu nodes toe, en bij elke
  // mutatie de hele pagina afzoeken kost merkbaar rekentijd op een telefoon --
  // precies waar deze winkel het al zwaar heeft. Daarom uitgesteld en gebundeld,
  // en alleen zoeken in wat er daadwerkelijk bij kwam.
  var wachtend = null;
  var nieuweNodes = [];

  function verwerk() {
    wachtend = null;
    var batch = nieuweNodes;
    nieuweNodes = [];
    var raak = false;
    batch.forEach(function (n) {
      if (!n.isConnected) return;
      if (n.matches && n.matches('[data-wishlist-knop]')) { koppel(n); raak = true; return; }
      if (n.querySelector && n.querySelector('[data-wishlist-knop]')) { koppelAlles(n); raak = true; }
    });
    if (raak) tellerBij();
  }

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var toegevoegd = muts[i].addedNodes;
      for (var j = 0; j < toegevoegd.length; j++) {
        if (toegevoegd[j].nodeType === 1) nieuweNodes.push(toegevoegd[j]);
      }
    }
    if (nieuweNodes.length && !wachtend) {
      wachtend = (window.requestIdleCallback || window.setTimeout)(verwerk, { timeout: 500 });
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
